/**
 * DataDictionaryView Component
 *
 * View wrapper for Data Dictionary Report.
 * Shows comprehensive data structures catalog.
 */

import { useState, useEffect } from 'react'
import { ArrowLeft, Loader2, AlertCircle, Database } from 'lucide-react'
import { DataDictionaryReport } from '../reports'
import { getDataModel, getJobResults } from '../../services/codeAnalysisService'
import './SharedReportView.css'

function DataDictionaryView({ onBack, analysisContext }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [dataModel, setDataModel] = useState(null)

  const jobContext = analysisContext

  // Fetch data model
  useEffect(() => {
    const fetchData = async () => {
      if (!jobContext?.jobId || !jobContext?.baseName) {
        setError('No code analysis data found')
        setLoading(false)
        return
      }

      setLoading(true)
      setError(null)

      try {
        // Resolve authoritative baseName — context value is app name (e.g. "tims-test-project"),
        // actual artifact prefix is the COBOL program name (e.g. "custupd")
        let baseName = jobContext.baseName
        try {
          const jobMeta = await getJobResults(jobContext.jobId)
          if (jobMeta?.base_name) baseName = jobMeta.base_name
        } catch (e) {
          console.debug('[DataDictionary] Could not resolve baseName from /results, using context value')
        }

        const data = await getDataModel(jobContext.jobId, baseName)
        setDataModel(data)
      } catch (err) {
        console.error('Failed to fetch data dictionary:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [jobContext])

  return (
    <div className="report-view">
      {/* Header */}
      <div className="report-header">
        <button onClick={onBack} className="back-btn">
          <ArrowLeft size={20} />
          Back to Reports
        </button>
        <div className="header-title">
          <Database size={24} />
          <h1>Data Dictionary</h1>
        </div>
      </div>

      {/* Content */}
      <div className="report-content">
        {loading ? (
          <div className="loading-state">
            <Loader2 size={32} className="spin" />
            <p>Loading data dictionary...</p>
          </div>
        ) : error ? (
          <div className="error-state">
            <AlertCircle size={32} />
            <p>{error}</p>
            <button onClick={onBack} className="secondary-btn">
              Go Back
            </button>
          </div>
        ) : (
          <DataDictionaryReport
            dataModel={dataModel}
            title="Data Dictionary"
          />
        )}
      </div>
    </div>
  )
}

export default DataDictionaryView
